/**
 * 商品詳細の原価まわりの表示状態（「算出中」か「警告アイコン」か）を決める。
 *
 * 原価が出せない理由は2種類あり、ユーザーに見せるべき表示が異なる。
 *  - あとで確定するだけの状態（再計算ジョブ実行中／未登録原材料の登録待ち／
 *    レシピが下書き）→「算出中」
 *  - ユーザーの入力不足（仕入値未登録・焼成前生地量未入力・焼減率未入力など）
 *    →「警告アイコン」
 *
 * NumberBox は alert を isCostCalculating より先に判定するため、
 * 「算出中」を出したいケースでは alert を false にする必要がある。
 */
export type CostDisplayInput = {
  // ライブ計算した原価。算出不可なら null
  costPrice: number | null
  sellPrice: number | null
  // Cloud Functions の再計算ジョブが実行中か（breads.is_cost_calculating）
  isCostCalculating: boolean
  // 未登録原材料や解決できない参照を含むか
  hasUnregisteredMaterial: boolean
  // レシピが未確定（下書き）か。複製直後もこの状態になる
  isRecipeUnconfirmed: boolean
}

export type CostDisplayState = {
  // 原価・材料費を「算出中」と表示する
  isCostPending: boolean
  // 原価・材料費に警告アイコンを表示する
  isCostAlert: boolean
  // 原価率を「算出中」と表示する
  isCostRatePending: boolean
  // 原価率に警告アイコンを表示する
  isCostRateAlert: boolean
}

export const resolveCostDisplayState = ({
  costPrice,
  sellPrice,
  isCostCalculating,
  hasUnregisteredMaterial,
  isRecipeUnconfirmed,
}: CostDisplayInput): CostDisplayState => {
  const isCostPending =
    isCostCalculating || hasUnregisteredMaterial || isRecipeUnconfirmed
  const isCostAlert = !isCostPending && costPrice === null
  // 売価未入力は原価の算出状態と無関係な入力不足なので、常に警告のまま
  const isCostRateAlert = sellPrice === null || isCostAlert
  return {
    isCostPending,
    isCostAlert,
    isCostRatePending: !isCostRateAlert && isCostPending,
    isCostRateAlert,
  }
}
